export default __webpack_public_path__ + "static/media/casadhort.56e498fa.jpg";